import { render, staticRenderFns } from "./FireElectricalCauseCommonParts.vue?vue&type=template&id=2f2e2d9c&scoped=true"
import script from "./FireElectricalCauseCommonParts.vue?vue&type=script&lang=ts"
export * from "./FireElectricalCauseCommonParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e2d9c",
  null
  
)

export default component.exports